import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { addWhitelist, deleteWhitelist, importWhitelist, listWhitelist, type ListWhitelistParams } from "./api";

export const WHITELIST_QK = ["admin", "whitelist"] as const;
export const ADMIN_USERS_QK = ["admin", "users"] as const;

export function useWhitelist(params: ListWhitelistParams) {
  return useQuery({
    queryKey: [...WHITELIST_QK, params],
    queryFn: () => listWhitelist(params),
    staleTime: 5_000,
  });
}

export function useAddWhitelist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ email, note }: { email: string; note?: string }) =>
      addWhitelist(email, note),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: WHITELIST_QK });
      qc.invalidateQueries({ queryKey: ADMIN_USERS_QK });
    },
  });
}

export function useDeleteWhitelist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (email: string) => deleteWhitelist(email),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: WHITELIST_QK });
      qc.invalidateQueries({ queryKey: ADMIN_USERS_QK });
    },
  });
}

export function useImportWhitelist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (file: File) => importWhitelist(file),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: WHITELIST_QK });
      qc.invalidateQueries({ queryKey: ADMIN_USERS_QK });
    },
  });
}
